const { createSlice } = require("@reduxjs/toolkit");

const initialState = {
  tags: [],
  author: "",
  search: "",
};

const filterSlice = createSlice({
  name: "pagination",
  initialState,
  reducers: {
    tagSelected: (state, action) => {
      state.tags.push(action.payload);
    },
    tagRemoved: (state, action) => {
      const indexToRemove = state.tags.indexOf(action.payload);

      if (indexToRemove !== -1) {
        state.tags.splice(indexToRemove, 1);
      }
    },
    authorSelected: (state, action) => {
      if (state?.author === action?.payload) {
        state.author = "";
      } else {
        state.author = action.payload;
      }
    },
    searched: (state, action) => {
      state.search = action.payload;
    },
    clearFilter: (state) => {
      state.tags = [];
      state.search = "";
      state.author = "";
    },
  },
});

export default filterSlice.reducer;
export const {
  tagSelected,
  tagRemoved,
  searched,
  clearFilter,
  authorSelected,
} = filterSlice.actions;
